import { Checkbox } from 'primereact/checkbox';
import React from 'react';

export interface AddUserDialogSelectUserTypeDataModel {
  text: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}
export const AddUserDialogSelectUserType: React.FC<
  AddUserDialogSelectUserTypeDataModel
> = ({ text, checked, onChange }) => {
  return (
    <div className="flex align-items-center" style={{ marginLeft: '8px' }}>
      <Checkbox
        inputId="ingredient2"
        name="pizza"
        value="Mushroom"
        checked={checked}
        onChange={(e) => /*onClick(!!e.checked)*/ {
          onChange(!!e.checked);
        }}
      />
      <label
        htmlFor="ingredient2"
        className="ml-2"
        style={{ marginRight: '4px' }}
      >
        {text}
      </label>
    </div>
  );
};
